import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.core.common.value.types.Intrinsic,
    graphql.schema.IntrinsicValueType
  >({
    [ents.core.common.value.types.Intrinsic.Boolean]:
      graphql.schema.IntrinsicValueType.Boolean,
    [ents.core.common.value.types.Intrinsic.Text]:
      graphql.schema.IntrinsicValueType.Text,
    [ents.core.common.value.types.Intrinsic.Integer]:
      graphql.schema.IntrinsicValueType.Int,
    [ents.core.common.value.types.Intrinsic.Currency]:
      graphql.schema.IntrinsicValueType.Currency,
    [ents.core.common.value.types.Intrinsic.Date]:
      graphql.schema.IntrinsicValueType.Date,
    [ents.core.common.value.types.Intrinsic.DateMultirange]:
      graphql.schema.IntrinsicValueType.DateMultirange,
    [ents.core.common.value.types.Intrinsic.DateRange]:
      graphql.schema.IntrinsicValueType.DateRange,
    [ents.core.common.value.types.Intrinsic.Decimal]:
      graphql.schema.IntrinsicValueType.Decimal,
    [ents.core.common.value.types.Intrinsic.List]:
      graphql.schema.IntrinsicValueType.List,
    [ents.core.common.value.types.Intrinsic.Object]:
      graphql.schema.IntrinsicValueType.Object,
    [ents.core.common.value.types.Intrinsic.Percent]:
      graphql.schema.IntrinsicValueType.Percent,
    [ents.core.common.value.types.Intrinsic.Url]:
      graphql.schema.IntrinsicValueType.Url,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.IntrinsicValueType,
    ents.core.common.value.types.Intrinsic
  >({
    [graphql.schema.IntrinsicValueType.Boolean]:
      ents.core.common.value.types.Intrinsic.Boolean,
    [graphql.schema.IntrinsicValueType.Text]:
      ents.core.common.value.types.Intrinsic.Text,
    [graphql.schema.IntrinsicValueType.Int]:
      ents.core.common.value.types.Intrinsic.Integer,
    [graphql.schema.IntrinsicValueType.Currency]:
      ents.core.common.value.types.Intrinsic.Currency,
    [graphql.schema.IntrinsicValueType.Date]:
      ents.core.common.value.types.Intrinsic.Date,
    [graphql.schema.IntrinsicValueType.DateMultirange]:
      ents.core.common.value.types.Intrinsic.DateMultirange,
    [graphql.schema.IntrinsicValueType.DateRange]:
      ents.core.common.value.types.Intrinsic.DateRange,
    [graphql.schema.IntrinsicValueType.Decimal]:
      ents.core.common.value.types.Intrinsic.Decimal,
    [graphql.schema.IntrinsicValueType.List]:
      ents.core.common.value.types.Intrinsic.List,
    [graphql.schema.IntrinsicValueType.Object]:
      ents.core.common.value.types.Intrinsic.Object,
    [graphql.schema.IntrinsicValueType.Percent]:
      ents.core.common.value.types.Intrinsic.Percent,
    [graphql.schema.IntrinsicValueType.Url]:
      ents.core.common.value.types.Intrinsic.Url,
  }),
)
